import { Form } from '@ant-design/compatible'

import ManageOperatorForm from './ManageOperatorForm'

export default Form.create({
  name: 'operatorForm',
})(ManageOperatorForm)
